import React, { useEffect, useState } from "react";
import userService from "../../../app/services/user.service";
import { useSearchParams } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../../assets/img/motion_new_logo.png";
import footer from "../../../assets/img/footer_icon.jpg";
import backImage from "../../../assets/img/back_page-0001.jpg";
import styles from "./AnswerKey.module.css";
import Loader from "../../../UI/loader/loader";
import { isEmpty } from "../../../utils/custom_funtions";
import { uid } from "react-uid";
import footerImg from "../../../assets/img/footer1.jpg"


const ArrayTable = ({ data, info }) => {
  const chunkedData = [];
  for (let i = 0; i < data.length; i += 8) {
    chunkedData.push(data.slice(i, i + 8));
  }

  const optionMapping = {
    A: "(1)",
    B: "(2)",
    C: "(3)",
    D: "(4)",
    E: "(5)",
    F: "(6)",
  };

  return (
    <div>
      {chunkedData.map((row, rowIndex) => (
        <div key={rowIndex} style={{
          display: 'flex',
          width: '100%',
          marginBottom: '10px',
          lineHeight: '0.1',
          justifyContent: "center",
        }} className={styles.rowfield}>
          {row.map((item, colIndex) => (
            <div key={colIndex} style={{
              flex: '1 0 12.5%', // Each item takes exactly 12.5% (100% / 8)
              padding: '6px',
              // border: '1px solid #ddd', // Optional: for visualization
              textAlign: 'left',
              boxSizing: 'border-box',
              fontSize: '21px',
              fontWeight: 'bold',


            }} className={styles.optionfield} >
              {item.display_number}.
              {item.answer}
            </div>
          ))}
          {/* Fill empty spaces in incomplete rows */}
          {Array.from({ length: 8 - row.length }, (_, index) => (
            <div key={`empty-${index}`} style={{
              flex: '1 0 12.5%',
              padding: '8px'
            }}></div>
          ))}
        </div>
      ))}
    </div>
  );
};
const ArrayTable1 = ({ data, info }) => {
  const chunkedData = [];
  for (let i = 0; i < data.length; i += 5) {
    chunkedData.push(data.slice(i, i + 5));
  }

  return (
    <div>
      {chunkedData.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className={`${styles.rowfield} w-100`}
          
          style={{
            display: "flex",
            // width: "100% !important",
            marginBottom: "5px",
            lineHeight: "1",
            gap:'5px',
            justifyContent: "center",
            
          }}
        >
          {row.map((item, colIndex) => (
            <div
              key={colIndex}
              className={`${styles.optionfield1} w-100`}
              style={{
                flex: "1 0 19%",      // ✅ 5 columns = 20%
                padding: "2px 10px",       // ✅ same as ArrayTable
                textAlign: "left",
                fontWeight: "500",
                fontSize: "16px",
                
              }}
            >
              {item.display_number}.QID-{item.qid}
            </div>
          ))}

          {/* Fill empty cells correctly */}
          {Array.from({ length: 5 - row.length }, (_, index) => (
            <div
              key={`empty-${index}`}
              style={{
                flex: "1 0 19%",     // ✅ MUST match column width
                padding: "3px",
                // boxSizing: "border-box",
              }}
            />
          ))}
          
        </div>
      ))}
    </div>
  );
};


const ArrayTable2 = ({ data, info }) => {
  const chunkedData = [];
  for (let i = 0; i < data.length; i += 8) {
    chunkedData.push(data.slice(i, i + 8));
  }
  return (
    <div>
      {chunkedData.map((row, rowIndex) => (
        <div key={rowIndex} style={{
          display: 'flex',
          width: '100%',
          marginBottom: '2px',
          justifyContent: "center",
        }}
        className={styles.rowfield}
        >
          {row.map((item, colIndex) => (
            <div key={colIndex} style={{
              flex: '1 0 12.5%', // Each item takes exactly 12.5% (100% / 8)
              padding: '2px 12px',
              // border: '1px solid #ddd', // Optional: for visualization
              textAlign: 'center',
              boxSizing: 'border-box',
              fontWeight: '600',
              fontSize: '18px',

            }}
            className={styles.optionfield}
            >
              {`QNO.${item.display_number}`}
            </div>
          ))}
          {/* Fill empty spaces in incomplete rows */}
          {Array.from({ length: 8 - row.length }, (_, index) => (
            <div key={`empty-${index}`} style={{
              flex: '1 0 12.5%',
              padding: '2px 8px .'
            }}></div>
          ))}
        </div>
      ))}
    </div>
  );
};

const AnswerKey = () => {
  const [searchParams] = useSearchParams();
  const [info, setInfo] = useState({});
  const [subjectArr, setSubjectArr] = useState([]);
  const [sectionArr, setSectionArr] = useState([]);
  const [facultyArr, setFacultyArr] = useState([]);
  const [quesData, setQuesData] = useState([]);
  const [loading, setLoading] = useState(false);

  // When number_sequence === 3, numbering should be continuous per subject across sections/groups
  const isSubjectWiseNumbering = info && info.number_sequence == 3;
  const subjectCounters = {};
  const getAnswerKeys = () => {
    setLoading(true);
    userService
      .getPaperInfo(searchParams.get("paperid"))
      .then((res) => {
        // console.log(Object.values(res.data.data[0]))

        const response = res.data.data;
        const datas = {
          ...response,
          // to_be_held_on: convertDate(res.data.data[0][0].to_be_held_on),
        };
        console.log(datas.paperdetail.paper_name);
        document.title = `${datas.paperdetail.paper_name}_${datas.paperdetail.to_be_held_on}_${datas.paperdetail.center}`;
        setInfo(datas.paperdetail);
        // setQuesData(Object.values(res.data.data[0]))
        userService
          .getAnswerKey(
            searchParams.get("paperid"),
            "'" + datas.sub_sequence + "'"
          )
          .then((res) => {
            console.log(Object.values(res.data.data));
            const quesdatas = Object.values(res.data.data[0]);
            const subList = [...new Set(quesdatas.map((x) => x.subject))];
            const sectionList = [
              ...new Set(quesdatas.map((x) => x.section_name)),
            ];
            setSectionArr(sectionList);
            setSubjectArr(subList);
            console.log(subList);
            setQuesData(quesdatas);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };




  const getQuestionMapping = () => {
    setLoading(true);
    userService
      .getPaperInfo(searchParams.get("paperid"))
      .then((res) => {
        const response = res.data.data;
        const datas = {
          ...response,
        };
        console.log(datas.paperdetail);
        document.title = `${datas.paperdetail.paper_name}_${datas.paperdetail.to_be_held_on}_${datas.paperdetail.center}`;
        setInfo(datas.paperdetail);
        userService
          .getQuestionMapping(
            searchParams.get("paperid"),
            "'" + datas.sub_sequence + "'"
          )
          .then((res) => {
            const quesdatas = Object.values(res.data.data[0]);
            const subList = [...new Set(quesdatas.map((x) => x.subject))];
            const FacultyList = [...new Set(quesdatas.map((x) => x.user_name))];
            console.log("FacultyList", FacultyList);
            setFacultyArr(FacultyList);

            setSubjectArr(subList);
            console.log(subList);
            setQuesData(quesdatas);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    const key = searchParams.get("key");
    if (key == 0 || key == 1 || key == 2) {
      getAnswerKeys();
    } else if (key == 3) {
      getQuestionMapping();
    }
    // getQuestionMapping()
  }, []);

  const setPrintPageSize = (size) => {
    let style = document.getElementById("dynamic-print-page-size");

    if (!style) {
      style = document.createElement("style");
      style.id = "dynamic-print-page-size";
      document.head.appendChild(style);
    }

    style.innerHTML = `
      @media print {
        @page {
          size: ${size};
          margin: .5in .35in !important; 
          
        }
      }
    `;
  };

  useEffect(() => {
    // Bulk Question Request size
    setPrintPageSize("A4");

    return () => {
      // Cleanup when leaving page
      const style = document.getElementById("dynamic-print-page-size");
      if (style) style.remove();
    };
  }, []);

  function convertDate(dateStr) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Split the input date string
    const parts = dateStr.split("-");

    // Extract year, month, and day
    const year = parts[0];
    const month = months[parseInt(parts[1], 10) - 1];
    const day = parts[2];

    // Combine them into the desired format
    const date = `${year}-${month}-${day}`;
    return date.split("-").reverse().join("-");
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* <button onClick={() => console.log(quesData)}>dvsv</button> */}
          <table style={{ width: "100%" }} className={`${styles.printable} print-page print-answer-key`}>
            <tbody style={{ marginBottom: "80px" }}>
              <tr>
                <td>
                  <div className={styles.printContainer}>
                    <div className={styles.logoContainer}>
                      <img src={logo} />
                    </div>
                    <p className={styles.title}>
                      {searchParams.get("key") === "0"
                        ? "Answer Key"
                        : searchParams.get("key") === "1"
                          ? "Answer Key Board"
                          : searchParams.get("key") === "2"
                            ? "Question Mapping"
                            : searchParams.get("key") === "3"
                              ? "Faculty Question Mapping"
                              : ""}{" "}
                      {`[CODE - ${info.paper_id}]`}
                    </p>
                    <p className={styles.title}>{info.paper_name}</p>
                    <p className={styles.title}>
                      {/* {`${info.class} ${info.target} - ${info.phase} : ${info.center}`} */}
                      {/* {info.batch_name && (
                        <p className={styles.title}>{info.batch_name}</p>
                      )} */}
                    </p>

                    <div className={styles.paperDetail}>
                      <p className={styles.title}>Date: {info.to_be_held_on}</p>
                      <p className={styles.title}>Duration: {info.duration} </p>
                      <p className={styles.title}>
                        Max Marks:{" "}
                        {isEmpty(info.max_marks)
                          ? info.total_marks
                          : info.max_marks}
                      </p>
                    </div>
                    {searchParams.get("key") == 0 && (
                      <>
                        {subjectArr.map((sub) => (
                          <>
                            {sectionArr.map((sec) => (
                              <>
                                {!isEmpty(
                                  quesData.filter(
                                    (x) =>
                                      x.subject == sub && x.section_name == sec
                                  )
                                ) && (
                                    <div
                                      className={styles.unbreakableDiv}
                                      key={sec}
                                    >
                                      <div className={styles.tableTitle}>
                                        <span>
                                          {sub} - {sec}
                                        </span>
                                      </div>

                                      <ArrayTable
                                        data={(
                                          () => {
                                            const filtered = quesData.filter(
                                              (x) => x.subject == sub && x.section_name == sec
                                            );
                                            if (!isSubjectWiseNumbering) return filtered;
                                            return filtered.map((item) => ({
                                              ...item,
                                              display_number: (subjectCounters[sub] = (subjectCounters[sub] || 0) + 1),
                                            }));
                                          }
                                        )()}
                                        info={info}
                                      />

                                    </div>
                                  )}
                              </>
                            ))}
                          </>
                        ))}
                      </>
                    )}
                    {searchParams.get("key") == 1 && (
                      <>
                        {subjectArr.map((sub) => (
                          <>
                            {sectionArr.map((sec) => (
                              <>
                                {!isEmpty(
                                  quesData.filter(
                                    (x) =>
                                      x.subject == sub && x.section_name == sec
                                  )
                                ) && (
                                    <div
                                      className={styles.unbreakableDiv}
                                      key={sec}
                                    >
                                      <div className={styles.tableTitle}>
                                        <span>
                                          {sub} - {sec}
                                        </span>
                                      </div>

                                      <ArrayTable
                                        data={(
                                          () => {
                                            const filtered = quesData.filter(
                                              (x) => x.subject == sub && x.section_name == sec
                                            );
                                            if (!isSubjectWiseNumbering) return filtered;
                                            return filtered.map((item) => ({
                                              ...item,
                                              display_number: (subjectCounters[sub] = (subjectCounters[sub] || 0) + 1),
                                            }));
                                          }
                                        )()}
                                        info={info}
                                      />

                                    </div>
                                  )}
                              </>
                            ))}
                          </>
                        ))}
                      </>
                    )}

                    {searchParams.get("key") == 2 && (
                      <>
                        {subjectArr.map((sub) => (
                          <>
                            {sectionArr.map((sec) => (
                              <>
                                {!isEmpty(
                                  quesData.filter(
                                    (x) =>
                                      x.subject == sub && x.section_name == sec
                                  )
                                ) && (
                                    <div
                                      className={styles.unbreakableDiv}
                                      key={sec}
                                    >
                                      <div className={styles.sectionBlock}>
                                        <div className={styles.tableTitle}>
                                          <span>
                                            {sub} - {sec}
                                          </span>
                                        </div>
                                      </div>

                                      <ArrayTable1
                                        data={(
                                          () => {
                                            const filtered = quesData.filter(
                                              (x) => x.subject == sub && x.section_name == sec
                                            );
                                            if (!isSubjectWiseNumbering) return filtered;
                                            return filtered.map((item) => ({
                                              ...item,
                                              display_number: (subjectCounters[sub] = (subjectCounters[sub] || 0) + 1),
                                            }));
                                          }
                                        )()}
                                        info={info}
                                      />

                                    </div>
                                  )}
                              </>
                            ))}
                          </>
                        ))}
                      </>
                    )}
                    {searchParams.get("key") == 3 && (
                      <>
                        {subjectArr.map((sub) => (
                          <>
                            {facultyArr.map((faculty) => (
                              <>

                                {!isEmpty(
                                  quesData.filter(
                                    (x) =>
                                      x.subject == sub && x.user_name == faculty
                                  )
                                ) && (
                                    <div
                                      className={styles.unbreakableDiv}
                                      key={sub}
                                    >
                                      <div className={styles.tableTitle}>
                                        <span>
                                          {sub} - {faculty}
                                        </span>
                                      </div>

                                      <ArrayTable2
                                        data={(
                                          () => {
                                            const filtered = quesData.filter(
                                              (x) => x.subject == sub && x.user_name == faculty
                                            );
                                            if (!isSubjectWiseNumbering) return filtered;
                                            return filtered.map((item) => ({
                                              ...item,
                                              display_number: (subjectCounters[sub] = (subjectCounters[sub] || 0) + 1),
                                            }));
                                          }
                                        )()}
                                        info={info}
                                        conditionKey={searchParams.get("key")}
                                      />
                                    </div>
                                  )}
                              </>
                            ))}
                          </>
                        ))}
                      </>
                    )}

                    {(searchParams.get("key") == 0 ||
                      searchParams.get("key") == 1 || searchParams.get("key") == 2 ) && (
                        <>
                          <div class={styles.pageBreak}></div>
                          <div className="text-center">
                            <img src={backImage} style={{ width: "92%" ,height:"auto" }} />
                          </div>
                        </>
                      )}
                      
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <div className={styles.footer}>

                    <img
                      src={footerImg}
                      alt="Footer"
                      style={{ width: "100%", height: "35px", }}
                    />
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </>
      )}
    </>
  );
};

export default AnswerKey;
